<template lang="pug">
	.app-core--horizontal-scroll(ref="scroll", :style="{ '--size': `${height}px`, '--thumbWidth': `${thumbWidth}px` }", @click="onClick", @mousedown="onMouseDown")
		.thumb-holder
			.thumb(ref="thumb", :style="{ '--pos': `${thumbPosition}%`}")
</template>

<script>

import VueTypes from 'vue-types';

export default {
	props: {
		total: VueTypes.number.def(100),
		window: VueTypes.number.def(20),
		position: VueTypes.number.def(0),
		height: VueTypes.number.def(20)
	},
	components: {  },
	data() {
		return {
			thumbPosition: this.position / this.total
		}
	},
	computed: {
		thumbWidth() {
			return Math.max(10, this.window / this.total * this.tWidth);
		},
		tWidth: {
			get: function() {
				return this.$refs.scroll?.offsetWidth;
			},
			cache: false
		}
	},
	watch: {
		position(v) {
			if (this.thumbPosition !== v && !this.$isMoving) {
				this.thumbPosition = v;
			}
		}
	},
	mounted() {
		if (__DEBUG__)
			window.hScroll = this;

		document.body.addEventListener('mousemove', this.onBodyMouseMove);
		document.body.addEventListener('mouseup', this.onBodyMouseUp);
	},
	destroyed() {
		document.body.removeEventListener('mousemove', this.onBodyMouseMove);
		document.body.removeEventListener('mouseup', this.onBodyMouseUp);
		delete this.$offsetX;
	},
	methods: {
		onBodyMouseMove(e) {
			if (this.$isMoving && e.buttons === 1) {
				this.$offsetX = (this.$offsetX + e.movementX);
				this.process(this.$offsetX || 0);
			}
		},
		onMouseDown(e) {
			this.$offsetX = e.offsetX;
			this.$isMoving = true;
		},
		onBodyMouseUp() {
			this.$isMoving = false;
		},
		process(offsetX) {
			let half = this.$refs.thumb.offsetWidth / 2;
			let coef = Math.max(0, Math.min(1, Math.max(offsetX - half, 0) / (this.$refs.scroll.offsetWidth - half * 2)));
			this.thumbPosition = coef * 100;

			this.$emit('scroll', coef, coef * this.total);
		},
		onClick(e) {
			this.process(e.offsetX);
		},
		onMove(e) {
			if (e.buttons === 1 && e.srcElement === this.$refs.scroll) {
				this.process(e);
			}
		}
	}
};
</script>
<style lang="scss">
	@import "main/themes/generated/variables.base.scss";

	.app-core--horizontal-scroll {
		width: 100%;
		height: var(--size);
		position: relative;
		cursor: pointer;
		transition: 0.2s;

		.thumb-holder {
			position: absolute;
			left: 0px;
			right: calc(var(--thumbWidth));
			height: 100%;
			pointer-events: none;
		}

		.thumb {
			position: absolute;
			height: 90%;
			top: 5%;
			width: var(--thumbWidth);
			left: var(--pos);

			&:before {
				content: '';
				position: absolute;
				top: 1px;
				left: 1px;
				right: 1px;
				bottom: 1px;
				background: rgba(0,0,0,0.3);
				border-radius: 4px;
			}
		}

		&:hover {
			background: rgba(0,0,0,0.1);
		}
	}
</style>
